'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import type { MenuItem } from '@workspace/ui/types';
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuItem as SidebarMenuItemWrapper,
  SidebarSeparator,
  useSidebar,
} from '../index';
import { SidebarLogo } from './sidebar-logo';
import { CustomSidebarMenuItem } from './sidebar-menu-item';
import { SidebarOverlay } from './sidebar-overlay';

export function AppSidebar({ menuItems }: { menuItems: MenuItem[] }) {
  const { state } = useSidebar();

  const mainMenuItems = menuItems.filter((item) => !item.bottom && !item.bottomSeparated);
  const bottomMenuItems = menuItems.filter((item) => item.bottom);
  const bottomSeparatedItems = menuItems.filter((item) => item.bottomSeparated);

  return (
    <>
      <SidebarOverlay />

      <Sidebar variant="floating" collapsible="icon">
        <SidebarHeader>
          <SidebarLogo />
          {/* <SidebarToggle /> */}
        </SidebarHeader>

        <SidebarContent className="flex h-full flex-col">
          <SidebarGroup>
            <SidebarGroupContent>
              <SidebarSeparator
                className={`bg-grey-100 dark:bg-grey-600 relative mx-0 mb-6 ${state === 'collapsed' ? 'max-w-10' : ''}`}
              />

              <SidebarMenu>
                {mainMenuItems.map((item) => (
                  <SidebarMenuItemWrapper key={item.title}>
                    <CustomSidebarMenuItem item={item} />
                  </SidebarMenuItemWrapper>
                ))}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>

          <SidebarGroup className="mt-auto">
            <SidebarGroupContent>
              <SidebarMenu>
                {bottomMenuItems.map((item) => (
                  <SidebarMenuItemWrapper key={item.title}>
                    <CustomSidebarMenuItem item={item} />
                  </SidebarMenuItemWrapper>
                ))}

                {bottomSeparatedItems.length > 0 && (
                  <SidebarSeparator
                    className={`bg-grey-100 dark:bg-grey-600 relative m-0 ${state === 'collapsed' ? 'max-w-10' : ''}`}
                  />
                )}

                {bottomSeparatedItems.map((item) => (
                  <SidebarMenuItemWrapper key={item.title}>
                    <CustomSidebarMenuItem item={item} />
                  </SidebarMenuItemWrapper>
                ))}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        </SidebarContent>
      </Sidebar>
    </>
  );
}
